<div *ngIf="isLoading" class="cssload-container">
  <div class="cssload-speeding-wheel"></div>
</div>
